export function getParameterByName(name, url) {
    url = url || window.location.href;
    name = name.replace(/[[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(url);
    return results ? results[2] : undefined;
}
